import { Component, OnInit } from '@angular/core';
import { NavifyService } from '../../services/navify.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private readonly navifyService: NavifyService,
  ) { }

  ngOnInit() {
    this.navifyService.logOut()
  }
}
